import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { COMMAND_PRIORITY_LOW, SELECTION_CHANGE_COMMAND } from "lexical";
import { type FC, useCallback, useEffect, useState } from "react";
import { LinkForm } from "../../components/link-form/link-form";
import type { Link } from "../../components/link-form/types";
import { useLexicalContext } from "../../lexical-context";
import {
  INSERT_LINK_COMMAND,
  INSERT_SURVEY_LINK_COMMAND,
  REMOVE_LINK_COMMAND,
} from "../../types/commands";
import { $multipleElementsSelected } from "../../utils/multiple-elements-selected";

export const LinkModalPlugin: FC<{ disabled: boolean }> = ({ disabled }) => {
  const {
    filterTags,
    editorModal: { handleClose, open, data },
  } = useLexicalContext();

  const [forceDisabled, setForceDisabled] = useState(false);

  const [editor] = useLexicalComposerContext();

  const onConfirm = useCallback(
    ({ text: title, type, url }: Link): void => {
      if (type === "link_survey" || (data?.type === "link" && data.data.type === "survey_link")) {
        editor.dispatchCommand(INSERT_SURVEY_LINK_COMMAND, {
          title,
          url,
        });
      } else {
        editor.dispatchCommand(INSERT_LINK_COMMAND, { title, url });
      }

      handleClose();
    },
    [editor, handleClose, data],
  );

  const onRemove = useCallback(() => {
    editor.dispatchCommand(REMOVE_LINK_COMMAND, null);
    handleClose();
  }, [editor, handleClose]);

  useEffect(
    () =>
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        () => {
          setForceDisabled($multipleElementsSelected());

          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor],
  );

  if (!open || !data || data.type !== "link") return null;

  return (
    <LinkForm
      onRemove={onRemove}
      onCancel={handleClose}
      onConfirm={onConfirm}
      disabled={disabled || forceDisabled}
      filterTags={filterTags}
      data={data.data}
    />
  );
};
